import { CollectionAssetType } from '@Common/types/bo/collections';

import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const assetTypeChoices = makeChoicesCommon<CollectionAssetType>()({
  stock: 'resources.bo_common.asset_types.stock',
  crypto: 'resources.bo_common.asset_types.crypto',
  etf: 'resources.bo_common.asset_types.etf',
  'mutual-fund': 'resources.bo_common.asset_types.mutual_fund',
  commodity: 'resources.bo_common.asset_types.commodity',
  eltif: 'resources.bo_common.asset_types.eltif',
  'euro-fund': 'resources.bo_common.asset_types.euro_fund',
  empty: 'resources.bo_common.asset_types.empty',
  'structured-product': 'resources.bo_common.asset_types.structured_product',
  ccb: 'resources.bo_common.asset_types.ccb',
});
